import React from "react";

import { useRouter } from "./useRouter";

interface Props {
  routeParam: string;
  views: {
    [key: string]: (() => JSX.Element) | undefined;
  };
}

const RoutedTabPanelsComponent: React.FC<Props> = ({ views, routeParam }) => {
  const { searchParams } = useRouter<any, any>();

  const visibleRoutes = Object.keys(views);

  const paramValue = searchParams[routeParam];

  const renderMethod = views[paramValue];

  return renderMethod ? renderMethod() : views[visibleRoutes[0]]?.() ?? null;
};

export const RoutedTabPanels = React.memo(RoutedTabPanelsComponent);
